import {DEFAULT_FILTERS, BT_DEFAULT_FILTERS} from "../components/user/riaPowerSearch/defaultFilters";
import {featureFlag, hasAiAnalystEnabled, HOME_ADDRESS_FILTER_KEYS} from "../helpers/sessionUtils";
import {shouldRedactGender, shouldRedactAge} from "../helpers/utils";
import {isEmpty} from "lodash";

/**
 * Custom hook to get dataset-specific configuration for CustomFilters
 * @param {string} dataSet - The dataset type ('RIA' or 'BT')
 * @param {object} userSession - The user session object
 * @returns {object} Configuration object with defaultFilters, checkPerms, and apiEndpoint
 */
function useCustomFiltersConfig(dataSet, userSession) {
    const userTickers = userSession?.user_tickers || [];
    const hasTickers = !isEmpty(userTickers);

    const checkRiaPerms = (key) => {
        let show = true;
        if (['Your Custom M&A Fit', 'Acquisition Score', 'Producing Advisor Concentration'].includes(key))
            show = featureFlag(userSession, 'MaTab', 'advisor_ma');
        else if (key === 'Referral Network')
            show = featureFlag(userSession, "referral_network", "_");
        else if (key === 'Contact Email Domain')
            show = featureFlag(userSession, "contact_email_domains", "_");
        else if (key === 'ai_elements')
            show = hasAiAnalystEnabled(userSession);
        else if (['My ETF Alignment', 'ETF Win Lose'].includes(key))
            show = featureFlag(userSession, 'distribution_tab', 'distribution_tab') && hasTickers;
        else if (key === 'Age Range')
            show = !shouldRedactAge(userSession?.team_id);
        else if (key === 'Gender')
            show = !shouldRedactGender(userSession?.team_id);
        else if (HOME_ADDRESS_FILTER_KEYS.includes(key))
            show = featureFlag(userSession, 'home_address', '_');
        return show;
    };

    const checkBtPerms = () => {
        // Placeholder for future BT-specific permissions
        return true;
    };

    const getConfig = () => {
        switch (dataSet) {
            case 'RIA':
                return {
                    defaultFilters: DEFAULT_FILTERS,
                    currentFilters: userSession.custom_filters,
                    checkPerms: checkRiaPerms,
                    apiEndpoint: '/v1/user/users/update_custom_filters',
                    userKey: 'custom_filters',
                };
            case 'BT':
                return {
                    defaultFilters: BT_DEFAULT_FILTERS,
                    currentFilters: userSession.bt_custom_filters,
                    checkPerms: checkBtPerms,
                    apiEndpoint: '/v1/user/users/update_bt_custom_filters',
                    userKey: 'bt_custom_filters',
                };
        }
    };

    return getConfig();
}

export default useCustomFiltersConfig;


